// src/v2/v3/chokepoints.js — GENERATED from Ben's chokepoint research
// (benjaminwolf36/chokepoint-research · tracker/AI_Bottleneck_Master_Tracker_v2_May28.xlsx,
// Master List "In Atlas? = Yes" rows, snapshot 2026-07-05). Regenerate when
// the tracker updates — this is a committed snapshot, not a live join.
// NEVER surface this provenance (or the deal ordering) in user-facing copy —
// the UI shows only sector chips + cards.
//
// The tracker is the "Atlas-y" definition for the WatchDeck dealer: names that
// own a layer of the AI hardware supply chain. The generic hyperscalers
// (MSFT/META/ORCL/GOOG/AMZN) are deliberately NOT in the tracker, so they fall
// to the general pool — dealt, never the openers.
//
// Tiers from the tracker's Tier column:
//   CORE — monopoly/oligopoly/niche chokepoint owners (mostly small caps)
//   KEY  — key players (discovered)
//   BASE — tracker members without a tier label (the layer anchors: GEV, VRT,
//          TSM, ANET, AMAT … ASML is CORE)

const CORE = ['ASML', 'ATI', 'AXTI', 'CRS', 'IE', 'MTRN', 'NB', 'PLAB', 'PPTA', 'TMQ', 'UAMY']
const KEY = ['FN', 'MP', 'RMBS']
const BASE = [
  'AAOI', 'AAON', 'ACLS', 'ACMR', 'AEHR', 'AEIS', 'ALAB', 'ALB', 'ALGM', 'AMAT',
  'AMD', 'AMKR', 'AMSC', 'ANET', 'APD', 'APH', 'ARM', 'ASX', 'AVGO', 'BE',
  'BWXT', 'CCJ', 'CDNS', 'CIEN', 'COHR', 'COHU', 'CRDO', 'CRUS', 'DD', 'DELL',
  'DNN', 'ENTG', 'ESI', 'ETN', 'FCX', 'FORM', 'GFS', 'GLW', 'GEV', 'GNRC',
  'GTLS', 'HON', 'ICHR', 'INTC', 'IPGP', 'KLAC', 'KLIC', 'LEU', 'LIN', 'LITE',
  'LRCX', 'LSCC', 'MPWR', 'MRVL', 'MU', 'MXL', 'NVDA', 'NVMI', 'NVTS', 'OKLO',
  'ON', 'ONTO', 'PH', 'POET', 'POWI', 'QCOM', 'ROG', 'SCCO', 'SITM', 'SKYT',
  'SLAB', 'SMCI', 'SMR', 'SMTC', 'SNDK', 'SNPS', 'STX', 'TEL', 'TER', 'TPL',
  'TSM', 'TT', 'UCTT', 'UEC', 'UUUU', 'VECO', 'VIAV', 'VICR', 'VRT', 'WDC',
  'WOLF',
]

// ticker → tier weight (CORE 3 · KEY 2 · BASE 1); absence = not a chokepoint.
export const CHOKEPOINT_W = Object.fromEntries([
  ...CORE.map((t) => [t, 3]),
  ...KEY.map((t) => [t, 2]),
  ...BASE.map((t) => [t, 1]),
])
